import * as apiFunction from '@services/apiFunctions'

import { API_URLS } from '@services/apiRoutes'

export const getUserPermissions = async (userId: number) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.auth.users}/${userId}`,
    method: 'GET'
  })
}

export const getCompetenceDate = async (month: number) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.auth.getCompetenceDate}/obter-datas/${month}`,
    method: 'GET'
  })
}
